import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import connect from 'components/lib/connect';
import PrepositionalPhrase from './prepositional_phrase';

export function ItemPrepositionalPhrases({ isVisible, name }) {
  if (!isVisible) {
    return null;
  }

  return <PrepositionalPhrase complement={name} preposition="regarding" />;
}

ItemPrepositionalPhrases.propTypes = {
  isVisible: PropTypes.bool,
  name: PropTypes.string,
};

const ItemPrepositionalPhrasesContainer = connect(mapStateToProps)(ItemPrepositionalPhrases);
export default ItemPrepositionalPhrasesContainer;

function mapStateToProps({ getProvider }, { item }) {
  const profileProvider = getProvider('profile');

  const isVisible = item.isLink();
  const name = item.isLink() ? _.get(profileProvider.get(), 'name', '') : '';

  return {
    isVisible,
    name,
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/metadata/item_prepositional_phrases.jsx